var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fun_box"},[_c('h2',[_vm._v("功能查询")]),_vm._v(" "),_c('div',{staticClass:"fun_list"},[_c('div',{staticClass:"fun_one fun pointer_box"},[_c('img',{attrs:{"src":require("../../../static/images/com_images/icon_07.png"),"alt":""}}),_vm._v(" "),_c('span',{on:{"click":_vm.tofinish}},[_vm._v("已完成案件查询")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e3d2d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fac/fun.vue
// module id = null
// module chunks = 